import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

let cachedValue = null;
let cachedAt = 0;
const TTL_MS = 60_000; // 1 min cache

/**
 * Hook qui détermine si le centre d'aide doit être affiché publiquement.
 * - Admin : voit toujours le centre d'aide (override systématique).
 * - Autres rôles / anonyme : suivent le flag DB (default = caché).
 */
export function useHelpVisibility() {
  const { user } = useAuth();
  const isAdmin = !!user?.isAdmin;

  const [state, setState] = useState({
    visible: isAdmin ? true : cachedValue !== null ? cachedValue : null,
    loading: !isAdmin && cachedValue === null,
  });

  useEffect(() => {
    if (isAdmin) {
      setState({ visible: true, loading: false });
      return;
    }
    let cancelled = false;
    const now = Date.now();
    if (cachedValue !== null && now - cachedAt < TTL_MS) {
      setState({ visible: cachedValue, loading: false });
      return;
    }
    axios
      .get(`${API}/api/help/visibility`)
      .then((r) => {
        if (cancelled) return;
        const v = !!r.data?.visible;
        cachedValue = v;
        cachedAt = Date.now();
        setState({ visible: v, loading: false });
      })
      .catch(() => {
        if (cancelled) return;
        cachedValue = false;
        cachedAt = Date.now();
        setState({ visible: false, loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, [isAdmin]);

  return state;
}

export function invalidateHelpVisibilityCache() {
  cachedValue = null;
  cachedAt = 0;
}
